import { useCallback, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchPermanentJobsList } from '../../../../../services/pp';

export const usePermanentJobList = () => {
  const [filters, setFilters] = useState({
    page: 1,
    limit: 15,
    plan: '',
    recruiter: '',
    professionType: '',
    status: '',
    officeName: '',
    states: '',
  });

  const {
    data: response,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['fetchPermanentJobsList', filters],
    queryFn: () => fetchPermanentJobsList(filters),
    retry: false,
  });

  const handleFilterChanged = useCallback(
    (type, value) => {
      setFilters((prev) => ({ ...prev, [type]: value, page: 1 }));
    },
    [setFilters],
  );

  const handlePageChanged = useCallback(
    (page) => {
      setFilters((prev) => ({ ...prev, page }));
    },
    [setFilters],
  );

  const handleSortChanged = useCallback(
    (selectedColumn, sortDirection) => {
      setFilters((prev) => ({
        ...prev,
        sortBy: selectedColumn.id,
        sortOrder: sortDirection,
      }));
    },
    [setFilters],
  );

  return {
    data: response?.data || [],
    filters,
    isLoading,
    total: response?.metadata?.pagination?.total || 0,
    totalPages: Math.ceil((response?.metadata?.pagination?.total || 0) / filters.limit) || 1,
    isError,
    error,
    handleFilterChanged,
    handlePageChanged,
    handleSortChanged,
  };
};
